var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleRcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06177 14.3333C1.06177 8.04793 1.06177 4.90525 3.01438 2.95262C4.96702 1 8.1097 1 14.3951 1H17.7284C24.0138 1 27.1566 1 29.1091 2.95262C31.0618 4.90525 31.0618 8.04793 31.0618 14.3333V17.6667C31.0618 23.952 31.0618 27.0948 29.1091 29.0473C27.1566 31 24.0138 31 17.7284 31H14.3951C8.1097 31 4.96702 31 3.01438 29.0473C1.06177 27.0948 1.06177 23.952 1.06177 17.6667V14.3333Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7285 22.6666L19.8833 15.5118C20.5342 14.861 21.5895 14.861 22.2403 15.5118L26.8952 20.1666M12.7285 22.6666L14.3952 24.3333M12.7285 22.6666L9.74037 19.6785C9.08948 19.0276 8.03422 19.0276 7.38333 19.6785L5.22852 21.8333M14.3952 11C14.3952 12.841 12.9028 14.3333 11.0618 14.3333C9.2209 14.3333 7.72852 12.841 7.72852 11C7.72852 9.15901 9.2209 7.66663 11.0618 7.66663C12.9028 7.66663 14.3952 9.15901 14.3952 11Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleRcs);
export default __webpack_public_path__ + "static/media/googleRCS.a8bbb9e1bf6f5b9f18e8c226fcd65740.svg";
export { ForwardRef as ReactComponent };